// extracted by mini-css-extract-plugin
export default {"starter":"FailedGoalsList_starter__f-OWp","failed-goal-list":"FailedGoalsList_failed-goal-list__+3ARL","ok":"FailedGoalsList_ok__kFWo9"};